// Types de business
export const TYPE_OF_BUSINESS = [
  'Outdoor escape game',
  'Boat rental - cruise',
  'Tourism/travel accommodation',
  'Cycling holidays',
  'Boat rental - event',
  'Fireworks/drone shows',
  'Amusement park',
  'Event',
];

// Types de triggers
export const TYPE_OF_TRIGGER = ['Cumulated', 'Per hour'];

// Types de périls
export const PERIL_TYPE = ['Rain', 'Wind', 'Rain and Wind'];

// Choix pour les cellules
export const CHOICE_FOR_CELLS = ['8 cells', '0 cells'];

// Environnements API
export const API_ENVIRONMENTS = ['dev', 'preprod', 'prod'];

// Rôles acceptés par POST /admin-accounts/create et PUT /users/{user_id}
export const ADMIN_USER_ROLES = [
  { value: 'Admin', label: 'Administrateur' },
  { value: 'Restricted_admin', label: 'Administrateur restreint' },
  { value: 'Operations_limited', label: 'Opérations limitées' },
  { value: 'Readonly_reporting', label: 'Lecture seule (reporting)' },
  { value: 'Invite_sender', label: 'Envoi d\'invitations' },
];

// Le backend impose cette entreprise pour le rôle Admin (ADMIN_COMPANY_NAME, POST /admin-accounts/create)
export const DEFAULT_ADMIN_COMPANY_NAME = 'Orakle Weather';

export const normalizeAdminUserRole = (role) => {
  const normalized = String(role || '').trim().toLowerCase();
  const match = ADMIN_USER_ROLES.find(({ value }) => value.toLowerCase() === normalized);
  return match ? match.value : '';
};

// Routes de l'application
export const ROUTES = {
  LOGIN: '/admin/login',
  WELCOME: '/welcome',
  PREMIUM: '/premium',
  EXPOSURE: '/exposure',
  ADMIN_PARTNER: '/admin/partner',
  ADMIN_REFERENCE: '/admin/reference',
  ADMIN_EMAIL: '/admin/email',
  ADMIN_CLIENT: '/admin/client',
  TRIP_DAILY: '/trip/daily',
  TRIP_EXPOSURE_CLAIMS: '/trip/exposure-claims',
  TRIP_POLICIES: '/trip/policies',
  ACTIVITY_DAILY: '/activity/daily',
  ACTIVITY_EXPOSURE_CLAIMS: '/activity/claims',
  ACTIVITY_POLICIES: '/activity/policies',
  CLAIMS: '/claims',
};



